module.exports = __webpack_public_path__ + "img/e logo.46fd5b0c.svg";